module.exports = __webpack_public_path__ + "static/CyberMergina-01447a2f4a65626c182e1f0c9037a241.jpg";